import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import store from "app/store";
import { preAppLoadHooks, postAppLoadHooks } from "utils/globalHooks";
import App from "app/App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from './reportWebVitals';
import "./styles";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
preAppLoadHooks();
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
postAppLoadHooks();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
